export const cleanCopy = (obj) => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (err) {
    return obj;
  }
};

export default cleanCopy;
